var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77535 6C5.71883 5.95279 5.64175 5.89581 5.57324 5.83069C4.10022 4.43223 2.61522 3.04191 1.16618 1.62066C0.95379 1.41228 0.777371 1.04435 0.808201 0.772472C0.835606 0.523387 1.12165 0.235229 1.37343 0.0919649C1.69886 -0.0919999 2.07054 0.0154484 2.35144 0.277557C2.9612 0.848988 3.56582 1.42367 4.17045 1.99999C4.70313 2.50793 5.2341 3.01749 5.79076 3.54985C5.92265 3.43263 6.03741 3.33658 6.14532 3.23402C7.15587 2.27675 8.15615 1.30971 9.17528 0.360586C9.78846 -0.209216 10.6175 -0.0659519 10.7853 0.655255C10.8436 0.905968 10.7682 1.29506 10.5901 1.46926C9.02969 2.99633 7.43335 4.48758 5.84729 5.99023C5.83872 5.99674 5.81988 5.99349 5.77535 5.99837V6Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.03854b0a7d8ba77a1206cee0da447701.svg";
export { ForwardRef as ReactComponent };